import { setSkipState } from '@/src/store/slices/sportsV2Slice.ts'
import { store } from '@/src/store/store'
import { getUrlParams } from '@/src/utils/sports/sportsHelper.ts'
import { getAltenarParamsFromURL } from '@/src/utils/sports/sportsHelperWidget.ts'
import { useEffect } from 'react'

const useSportsEventsV2 = (ASB: unknown, urlParams: string) => {
  useEffect(() => {
    const popStateFunc = () => {
      const additionalParamsSTR = window.location.href.split('?')[1]
      if (!additionalParamsSTR) {
        window.history.back()
        return
      }

      store.dispatch(setSkipState(true))

      const url = new URL(document.location.href)
      const params = getAltenarParamsFromURL(url.searchParams)
      // @ts-ignore
      ASB.setParams(
        {
          ...params,
          lang: getUrlParams(urlParams).lang,
        },
        { triggerCallback: false },
      )
    }

    window.addEventListener('popstate', popStateFunc)
    return () => {
      window.removeEventListener('popstate', popStateFunc)
    }
  }, [ASB, urlParams])

  useEffect(() => {
    return () => {
      if (ASB) {
        // @ts-ignore
        ASB.destroy()
        store.dispatch(setSkipState(false))
      }
    }
  }, [ASB])
}

export default useSportsEventsV2
